import { isNullOrEmpty, normalizeString } from "../../../../../commons/util/HallAppUtil";
import { useEffect, useMemo, useState } from "react";

import AppButton from "../../../../../commons/buttons/AppButton";
import AppContainer from "../../../../../commons/containers/AppContainer";
import AppInput from "../../../../../commons/inputs/AppInput";
import AppLinkButton from "../../../../../commons/buttons/AppLinkButton";
import CustomerAPI from "../../../../customer/CustomerAPI";
import CustomerCard from "../../../../customer/components/CustomerCard";
import { Form } from "react-bootstrap";
import HallAppToast from "../../../../../commons/HallAppToast";

const customerAPI = new CustomerAPI();

function ARStep2({ nextStep, toBack }) {
  const [customers, setCustomers] = useState([]);
  const [customersTmp, setCustomersTmp] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    getAllCustomer();
  }, []);

  const getAllCustomer = async () => {
    try {
      const response = await customerAPI.getCustomers();
      setCustomers(response.data);
      setCustomersTmp(response.data);
    } catch (_) {
      setCustomers([]);
      setCustomersTmp([]);
      HallAppToast.genericError();
    }
  };

  const toNext = () => {
    if (isNullOrEmpty(selectedCustomer)) {
      HallAppToast.error("Selecione o(a) cliente.");
      return;
    }
    nextStep({ customer: selectedCustomer });
  };

  function search(value) {
    setSearchText(value);
    const normalizedValue = normalizeString(value);

    if (!normalizedValue) {
      setCustomersTmp(customers);
      return;
    }

    const results = customers.filter((c) => {
      const normalizedName = normalizeString(c.name);
      const normalizedPhone = normalizeString(c.whatsapp);
      return normalizedName.includes(normalizedValue) || normalizedPhone.includes(normalizedValue);
    });

    setCustomersTmp(results);
  }

  const selectedLabel = useMemo(() => {
    if (!selectedCustomer) return "Nenhum cliente selecionado";
    return selectedCustomer?.name || "Cliente selecionado";
  }, [selectedCustomer]);

  return (
    <div>
      {/* Cabeçalho */}
      <div className="mb-3">
        <div style={{ fontSize: 16, fontWeight: 700, lineHeight: "20px" }}>Selecione o cliente</div>
        <div className="text-muted" style={{ fontSize: 12 }}>
          Escolha o cliente que terá o agendamento recorrente.
        </div>

        {/* Feedback de seleção */}
        <div
          className="mt-2"
          style={{
            background: selectedCustomer ? "#f1f3ff" : "#fafafa",
            border: selectedCustomer ? "1px solid #e3e6ff" : "1px solid #eee",
            padding: "10px 12px",
            borderRadius: 14,
            fontSize: 13,
          }}
        >
          <span className="text-muted">Selecionado: </span>
          <span style={{ fontWeight: 700, color: "#1d1b4a" }}>{selectedLabel}</span>
        </div>
      </div>

      {/* Busca */}
      <div
        style={{
          background: "#fff",
          border: "1px solid #eee",
          borderRadius: 16,
          padding: 14,
          marginBottom: 12,
        }}
      >
        <Form>
          <AppInput
            label="Pesquisar cliente"
            name="search"
            errors={[]}
            value={searchText}
            placeholder="Nome ou WhatsApp…"
            onChange={(e) => search(e.target.value)}
          />
        </Form>

        <div className="text-muted" style={{ fontSize: 11, marginTop: 6 }}>
          {customersTmp.length} resultado(s)
        </div>
      </div>

      {/* Lista */}
      <div className="d-flex flex-column gap-2" style={{ paddingBottom: 90 }}>
        {customersTmp.map((c) => {
          const isSelected = selectedCustomer?.id === c.id;

          return (
            <div
              key={c.id}
              role="button"
              tabIndex={0}
              onClick={() => setSelectedCustomer(c)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") setSelectedCustomer(c);
              }}
              style={{
                borderRadius: 16,
                outline: "none",
                border: isSelected ? "2px solid #2f2a7a" : "1px solid transparent",
                background: isSelected ? "#f1f3ff" : "transparent",
                padding: isSelected ? 2 : 0,
              }}
            >
              {/* Mantém o CustomerCard, só controla o highlight por fora */}
              <CustomerCard
                customer={c}
                backgroundColor="#fff"
              />
            </div>
          );
        })}

        {customersTmp.length === 0 && (
          <div
            style={{
              background: "#fff",
              border: "1px solid #eee",
              borderRadius: 16,
              padding: 14,
            }}
          >
            <div style={{ fontWeight: 700 }}>Nenhum cliente encontrado</div>
            <div className="text-muted" style={{ fontSize: 12 }}>
              Tente pesquisar por outro nome ou número.
            </div>
          </div>
        )}
      </div>

      {/* Footer actions (sticky) */}
      <div
        className="ar-footer-actions"
        style={{
          position: "sticky",
          bottom: 0,
          padding: "10px 0",
          background: "linear-gradient(to top, #fff 70%, rgba(255,255,255,0))",
          borderTop: "1px solid #eee",
        }}
      >
        <AppContainer>
          <AppLinkButton name="Próximo" fullWidth={true} onClick={toNext} />
          <div style={{ marginTop: 10 }}>
            <AppButton name="Voltar" width="100%" onClick={toBack} />
          </div>
        </AppContainer>
      </div>
    </div>
  );
}

export default ARStep2;
